import React from 'react';
import { Tabs } from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import { useSelector } from 'react-redux';

import Summery from '../timeSheets/summary.attendance';
import Daily from '../timeSheets/dashboard.attendance';

import Custom from './incident_report';
import Performance from './performance_report';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
  <Sticky bottomOffset={80}>
    {({ style }) => (
      <DefaultTabBar
        {...props}
        className="site-custom-tab-bar color-primary"
        style={{ ...style }}
      />
    )}
  </Sticky>
);

function Index() {
  const { company } = useSelector((state) => state.auth);
  return (
    <React.Fragment>
      <h3 className="mb-3">Analytics & Reports </h3>
      <StickyContainer>
        <Tabs defaultActiveKey="1" renderTabBar={renderTabBar} size="large">
          <TabPane tab="Daily Attendance" key="1">
            <Daily />
          </TabPane>
          <TabPane tab="Attendance Summary" key="2">
            <Summery />
          </TabPane>
          <TabPane tab="Incident Reports" key="3">
            <Custom />
          </TabPane>
          <TabPane tab="Performance Report" key="4">
            <Performance />
          </TabPane>
        </Tabs>
      </StickyContainer>
    </React.Fragment>
  );
}

export default Index;
